import { FileReportUploadResponse, FileReportValidationStatusEnum } from '../../../types';

const mockFileReportUploadResponseSuccess: FileReportUploadResponse = {
  fileReportStatus: FileReportValidationStatusEnum.OK,
  fileReportUploadUID: '123123-123123-d32d322233-d33d22',
  fileReportSummaries: [
    {
      organizationName: 'Företaget AB',
      organizationNumber: '1234567890',
      refId: '001',
      totalEmploymentsReported: 10,
      reportPeriods: [
        {
          payMonth: '202410',
          payrollsReported: 3,
          payrollAmount: 124500,
        },
        {
          payMonth: '202408',
          payrollsReported: 6,
          payrollAmount: 522000,
        },
      ],
      totalPayrollsReported: 10,
      totalPayrollAmount: 145000,
    },
    {
      organizationName: 'Företaget AB',
      organizationNumber: '1234567890',
      refId: '002',
      totalEmploymentsReported: 8,
      reportPeriods: [
        {
          payMonth: '202408',
          payrollsReported: 4,
          payrollAmount: 187500,
        },
        {
          payMonth: '202409',
          payrollsReported: 5,
          payrollAmount: 516000,
        },
      ],
      totalPayrollsReported: 9,
      totalPayrollAmount: 703500,
    },
  ],
  formattedErrorMessages: [],
  errors: [],
  warnings: [
    {
      warningText: 'Lönen för Bengt Arvidsson är 390 034 kr. Kontrollera att detta är korrekt.',
    },
  ],
};

const mockFileReportUploadResponseWithWarning: FileReportUploadResponse = {
  ...mockFileReportUploadResponseSuccess,
  fileReportStatus: FileReportValidationStatusEnum.WITH_WARNINGS,
  warnings: [
    {
      warningText: 'Lönen för Bengt Arvidsson är 390 034 kr. Kontrollera att detta är korrekt.',
    },
  ],
};

const mockFileReportUploadResponseWithError: FileReportUploadResponse = {
  fileReportStatus: FileReportValidationStatusEnum.WITH_ERRORS,
  fileReportUploadUID: '123123-123123-d32d322233-d33d22',
  fileReportSummaries: [],
  formattedErrorMessages: ['Organisationsnumret i filen matchar inte ditt företag.'],
  errors: [
    {
      errorMessage: 'Organisationsnumret i filen matchar inte ditt företag.',
      schemaPath: '',
      instancePath: '',
      employeeId: '',
    },
  ],
  warnings: [],
};

export const mockFileReportUploadResponse = {
  success: mockFileReportUploadResponseSuccess,
  withError: mockFileReportUploadResponseWithError,
  withWarning: mockFileReportUploadResponseWithWarning,
};
